import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { ReactComponent as More1 } from 'ASSETS/svg/icon_more_1.svg'
import { ReactComponent as More2 } from 'ASSETS/svg/icon_more_2.svg'
import { ReactComponent as More3 } from 'ASSETS/svg/icon_more_3.svg'

const More = () => {
  const [actived, setActived] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  const cards = [
    {
      icon: More1,
      title: '实时快速转化',
      content: '云端实时高效处理，不受限于本地设备和操作系统性能',
    },
    {
      icon: More2,
      title: '在线使用',
      content: '无需下载或安装任何程序，即可完成图像处理',
    },
    {
      icon: More3,
      title: '服务安全可靠',
      content: '图片素材临时存储，1 小时后永久删除，保障图片安全',
    },
  ]

  const onWheelChange = (d: number, actived: number) => {
    if (d < 0 && actived < 2 && actived >= 0) {
      setActived(actived + 1)
    }
    if (d > 0 && actived < 3 && actived >= 1) {
      setActived(actived - 1)
    }
  }

  useEffect(() => {
    const dom = ref.current
    if (dom) {
      let startX: number
      let startY: number
      let endX: number
      let endY: number

      const onTouchStart = (event: TouchEvent) => {
        startX = event.touches[0].pageX
        startY = event.touches[0].pageY
      }

      const onTouchMove = (event: TouchEvent) => {
        endX = event.touches[0].pageX
        endY = event.touches[0].pageY

        if (Math.abs(startX - endX) > Math.abs(startY - endY)) {
          event.preventDefault()
        }
      }

      const onTouchEnd = () => {
        if (Math.abs(endX - startX) > Math.abs(endY - startY)) {
          onWheelChange(endX - startX, actived)
        }
      }

      dom.addEventListener('touchstart', onTouchStart)
      dom.addEventListener('touchmove', onTouchMove, { passive: false })
      dom.addEventListener('touchend', onTouchEnd)

      return () => {
        dom.removeEventListener('touchstart', onTouchStart)
        dom.removeEventListener('touchmove', onTouchMove)
        dom.removeEventListener('touchend', onTouchEnd)
      }
    }
  }, [actived])

  return (
    <Container>
      <div style={{ marginTop: '40px' }}>
        <H2>更多</H2>
        <ActiveH2>核心优势</ActiveH2>
      </div>
      <Content>veImageX 提供实时快速转化能力，可在线使用，并提供安全可靠的服务</Content>
      <CardContainer ref={ref} id="card-container">
        <CardContentContainer
          style={{ left: `${actived === 0 ? 16 : actived === 1 ? -134.5 : -269}px` }}
        >
          {cards.map((card) => {
            return (
              <Card key={card.title}>
                <card.icon
                  style={{
                    position: 'absolute',
                    left: 16,
                    top: 48,
                    width: 48,
                    height: 48,
                  }}
                ></card.icon>
                <CardTitle>{card.title}</CardTitle>
                <CardContent>{card.content}</CardContent>
              </Card>
            )
          })}
        </CardContentContainer>
      </CardContainer>
      <div style={{ marginTop: '21px', display: 'flex' }}>
        {[0, 1, 2].map((i) => {
          return <Point key={i} active={actived === i}></Point>
        })}
      </div>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  height: 582px;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: #f5f8ff;
`

const H2 = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #282f38;
`
const ActiveH2 = styled(H2)`
  color: #3370ff;
`

const Content = styled.div`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #4e5969;
  width: 279px;
  height: 44px;
  margin: 16px 0 32px 0;
`

const CardContainer = styled.div`
  padding-left: 16px;
  width: 100%;
  height: 268px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
`

const CardContentContainer = styled.div`
  transition: all ease 0.2s;
  position: absolute;
  padding-right: 16px;
  display: flex;
`

const Card = styled.div`
  width: 204px;
  height: 268px;
  background: #ffffff;
  box-shadow: 1px 3px 32px rgba(152, 167, 183, 0.1);
  border-radius: 12px;
  position: relative;
  margin-right: 8px;
`

const CardTitle = styled.div`
  left: 16px;
  top: 136px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1d2129;
  position: absolute;
`

const CardContent = styled.div`
  left: 16px;
  top: 176px;
  font-size: 13px;
  line-height: 22px;
  color: #4e5969;
  opacity: 0.8;
  position: absolute;
`

const Point = styled.div<{ active: boolean }>`
  width: 12px;
  height: 4px;
  border-radius: 4px;
  background-color: ${(props) => (props.active ? '#1664ff' : '#C9CDD4')};
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  &:not(:last-child) {
    margin-right: 4px;
  }
`

export default More
